module.exports = {
    "main": {
        "site_id": 1161,
        "subscribeToCashdesk": true,
        "title": "BetConstruct",
        "source": 99,
        "blockedProviders": {
            'VE': ['MGS', 'PTC', 'NET', 'RTG', 'EVL', 'SAG'],
        },
        "availableLanguages": {
            'eng': {
                'short': 'EN',
                'full': "English",
                'region': "UnitedKingdom",
                "order": 1
            },
            "spa": {
                "short": "ES",
                "full": "España",
                "region": "Spain",
                "order": 2
            },
            'por': {
                'short': 'PT',
                'full': "Português",
                "order": 5,
                "region": "Portugal"
            },
            "zhh": {
                "short": "ZH",
                "full": "简体中文",
                "order": 10
            },
            'geo': {
                'short': 'KA',
                'full': "ქართული",
                "order": 12
            },
            'swe': {
                'short': 'SE',
                'full': "Swedish",
                "order": 13
            },
            'ger': {
                'short': 'DE',
                'full': "Deutsch",
                "order": 14
            },
            'nor': {
                'short': 'NO',
                'full': "Norwegian",
                "order": 15
            },
            "fas": {
                "short": "FA",
                "full": "فارسی",
                "order": 16,
                "rtl": true
            },
            "fra": {
                "short": "FR",
                "full": "France",
                "region": "France",
                "order": 17
            },
            "dut": {
                "short": "NL",
                "full": "Nederlands",
                // "region": "Luxembourg",
                "order": 18
            },
            "arb": {
                "short": "AR",
                "full": "العربية",
                // "region": "Saudi Arabia",
                "order": 19
            },
            'chi': {
                'short': 'CHN',
                'full': "chinese",
                // 'region': "China",
                "order": 20
            },
            "pt-br": {
                "short": "PT-BR",
                "full": "Português do Brasil",
                "order": 6
            }
        },
        "disableGeoLocationLanguage": true,
        "disableAddEventsFromSameGame": true,
        "showSportsbookInterfaceSettings": false,
        "enableTabletVersion": true,
        "enableRuntimePopup": false,
        "popularGamesCount": 7,
        "video": {
            "availableVideoProviderIds": [1, 3, 5, 16, 19]
        },
        "googleAnalyticsId": 'UA-29242337-7',
    },
    "swarm": {
        "debugging": false, //enable websocket debugging
        "languageMap": {
            "pol": "eng",
            "por": "por_2",
            "pt-br": "por",
            "fre": "fra",
            "chi": "chn",
            "mac": "mkd",
            "bgr": "bul",
            "lat": "lav",
            "fas": "far",
            "rum": "ron"
        },
        "sendSourceInRequestSession": true,
        "sendTerminalIdlInRequestSession": false,
        "webSocketTimeout": 5000,
        //url: [{url: "https://192.168.250.189:8022"}],
        "url": [{
            "url": "https://eu-swarm-betshops-lp.betconstruct.com"
            //"url": "wss://eu-swarm-ls.betconstruct.com/"
        }],
        //websocket: [{url: "wss://192.168.250.189:8022"}],
        "websocket": [{
            "url": "wss://mrg-swarm-betshops-ws.betconstruct.com/"
            //"url": "wss://eu-swarm-ws.betconstruct.com/"
        }],
        // websocket: [{url: "ws://127.0.0.1:8080"}],
        "useWebSocket": true,
        "maxWebsocketRetries": 100, // maximum number of websocket reconnect attempts after which it will give up
        "webSocketRetryInterval": 2000 // retry interval, in milliseconds (will be increased after each unsuccessful retry by itself)
    },
    "virtualGames": {
        'enabled': true,
        'videoInUpperscreen': true,
        "providers": {
            "Betconstruct": {
                "name": "Betconstruct",
                "id": 15
            }
            // "Inspired": {
            //     "name": "Inspired",
            //     "id": 29
            // }
        }
    },
    "liveCasino": {
        "games": {
            "loaderStep": 35
        }
    },
    "casino": {
        "defaultFilteredProvider": ["PPG"],
        "urlPrefix": "https://games.betconstruct.com/",
        "games": {
            "loaderStep": 35
        }
    },
    "env": {
        "lang": "spa",
        "oddsFormat": "decimal"
    },
    "ticketIn": { 'enabled': false },
    "urlPrefix": "https://games.betconstruct.com/authorization.php?",
    "betting": {
        "enableBetBuilder": true,
        "enableExpressBonus": false,
        "totalOddsMax": 10000
    },
    "betBuilder": {
        "url": "https://betconstruct-prod-gen2.sportcastlive.com/markets",
        "licenseKey": "a6aa080b-cea9-4e3f-aa02-9fef8d1f0c8f",
        "password": "ewmFb896vwmHeRFp",
    },
    "rulesURL": "https://newbettingterminal-bc.betconstruct.com/rules/bcrules.pdf",
    "terminal": {
        "asianViewEnabled": true,
        "scrollButtons": true,
        "featuredGames": 3,
        "signInToAdmin": false,
        "setGameListDropDown": false,
        "disableLiveGamesInToday": true,
        "enableSignOutWithRfidButton": true,
        "asianViewTwoImportantMarkets": true,
        "marketsForAsian": ["WINNER", "HANDICAP"],
        "sportsbookSettingsTypes": ["standart", "asian"],
        "disableTicket": true,
    },
    "enableDraggable": true,
    "setDefaultBetSlipSettingType": true,
    "betslipInHomePage": true,
    "upper_screen": {
        "statistics_live": false,
        "statistics_prematch": true,
        "live_streaming": true,
        "live_animations": true
    },
    "financialButtons": [
        "Last entered bills and coins",
        "Stacker Balance",
        "Todays Report",
        "Encashment"
    ],    
    "openSectionNameOnClick": true,
    "colorForTimer": "#a9d52f",
    "availableOdds": [
        {
            "odds": 'decimal',
            "title": "Decimal",
            "enabled": true
        },
        {
            "odds": 'american',
            "title": "American",
            "enabled": true
        },
        {
            "odds": 'malay',
            "title": "Malaya",
            "enabled": true
        },
        {
            "odds": 'indo',
            "title": "Indo",
            "enabled": true
        },
        {
            "odds": 'hongkong',
            "title": "Hongkong",
            "enabled": true
        },
        {
            "odds": 'fractional',
            "title": "Fractional",
            "enabled": true
        }
    ],
    "headerItems": [
        {
            "url": "live",
            "name": "Live1",
            'enabled': true
        },
        {
            "url": "prematch",
            "name": "Prematch",
            'enabled': true
        },
        {
            "url": "today",
            "name": "Today",
            'enabled': true
        },
        {
            "url": "virtualGames",
            "name": "Virtual Games",
            'enabled': true
        },
        {
            "url": "casino",
            "name": "Casino",
            'enabled': true
        },
        {
            "url": "dealer",
            "name": "Live Casino",
            'enabled': true
        },
        {
            "url": "topGames",
            "name": "Top Games",
            'enabled': true
        },
        {
            "url": "horseRacing",
            "name": "Real Horse Racing",
            'enabled': false
        }
    ],
    "setOnlyBetcoGames": true,
    "homePageView": 1,
    "homePageCompetitionsCount": 9,
    "betslipExpandableIcon": true,
    "nextRacingEnabled": true,
    "enableTopGames": true,
    "runtimeOddsFormatDropdow": true,
    "homePageHorseRacing": true,
    "enableLiveClock": false,
    "defaultTerminalParams": { pid: 1161, tid: 15137, token: "ypoHBg==", currency: 'USD' },
    "staticStake": true,
    "staticStakeCounts": { default: [5, 10, 20, 50, 100] }
};
